import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON'; 
import { POI_base_url,POI_layersName,featureName } from '../../../Essentials/variables';
import { getLevel,getPreLevel } from '../../../Essentials/common_fn';
import _ from "lodash";
import { useEffect } from 'react';

  
// let Token=localStorage.getItem('token')
// useEffect(()=>{
//    Token=localStorage.getItem('token')
// },[])

function getUrl(name,State,District){
let ret = POI_base_url + '/' + _.replace(State,/ /g, '') + '/' + _.replace(District,/ /g, '') + '/' + _.replace(name,/ /g, '');
// console.log("retriving POI data: ",ret);
return ret;
}
function fetchTokenFromLocalStorage() {
  const token = localStorage.getItem('token');
  return token;
}
export function getPOILayer(name,map,selected,src_param,color_param){

  console.log('name,color_param',name,color_param)
  let Token = fetchTokenFromLocalStorage();
    
    let vectorSource = new VectorSource({
        // url: getUrl(name,selected.State,selected.District),
        loader: function(extent, resolution, projection, success, failure) {
            const proj = projection.getCode();
            const url = getUrl(name,selected?.State,selected?.District);
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.setRequestHeader('x-access-token',Token);
            const onError = function() {
              vectorSource.removeLoadedExtent(extent);
              failure();
            }
            xhr.onerror = onError;
            xhr.onload = function() {
              if (xhr.status == 200) {
                const features = vectorSource.getFormat().readFeatures(xhr.responseText);
                vectorSource.addFeatures(features);
                success(features);
              } else {
                onError();
              }
            }
            xhr.send();
          },
        format: new TopoJSON({
            layers: [POI_layersName[name]]
        }),
        overlaps: true,
    });
   // console.log(featureName[getLevel(selected)],selected[getLevel(selected)],getLevel(selected),selected);
    vectorSource.on('featuresloadend',(evt)=>{
                    let rvl_features = [];
                    let level = getLevel(selected);
                    evt.features.forEach((f)=>{
                        if(_.isEmpty(selected?.Village)){
                            if(_.replace(f.get(featureName[getPreLevel(level)])," District","") !== selected[getPreLevel(level)]){
                                rvl_features.push(f);
                            }
                        }else{
                            if(f.get(featureName[level]) !== selected[level]){
                                rvl_features.push(f);
                            }
                        }

                    });
                    rvl_features.forEach((f)=>{
                        evt.target.removeFeature(f);
                    });
    });


    // let style = new Style({
    //     image: new Icon({
    //       anchor: [0.5, 46],
    //       anchorXUnits: 'fraction',
    //       anchorYUnits: 'pixels',
    //       src: src_param,
    //       backgroundColor:color_param,
    //       color: color_param,
    //       scale: 0.7
    //     }),
    //   });

      let style = new Style({
        image: new Icon({
          anchor: [0.5, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: src_param,
          backgroundColor:color_param,
          color: color_param,
          scale: 0.7
        }),
      });

    let stylefn=(feature,resolution)=>{
      // console.log("Line 106",feature?.values_.MSIL_CODE);
      // if(feature?.values_.MSIL_CODE==='CNG Pumps'){
      //   style.getImage().setScale(0.01)
      // }
      let zoom=map.getView().getZoom();
      //Uncoment for zoom
      style.getImage().setScale(zoom/9)
      // console.log('poi icon scale',style)
      return style;
    }
    return new VectorLayer({
        source: vectorSource,
        style: style,
        style:stylefn,
        visible: true,
        zIndex: 9
    });

}
